import translationEnGb from "./locales/en-GB.json";
import translationEn from "./locales/en-US.json";
import translationEs from "./locales/es-MX.json";
import translationFil from "./locales/fil-PH.json";
import translationFr from "./locales/fr-FR.json";
import translationHi from "./locales/hi-IN.json";
import translationId from "./locales/id-ID.json";
import translationJa from "./locales/ja-JP.json";
import translationKo from "./locales/ko-KR.json";
import translationMs from "./locales/ms-MY.json";
import translationPa from "./locales/pa-IN.json";
import translationPt from "./locales/pt-BR.json";
import translationTh from "./locales/th-TH.json";
import translationTr from "./locales/tr-TR.json";
import translationVi from "./locales/vi-VN.json";
import translationZh from "./locales/zh-CN.json";
import translationZhHant from "./locales/zh-Hant-TW.json";

export const LOCALES = [
	"en-GB",
	"en-US",
	"es-MX",
	"fil-PH",
	"fr-FR",
	"hi-IN",
	"id-ID",
	"ja-JP",
	"ko-KR",
	"ms-MY",
	"pa-IN",
	"pt-BR",
	"th-TH",
	"tr-TR",
	"vi-VN",
	"zh-CN",
	"zh-Hant-TW",
] as const;

export type Locale = (typeof LOCALES)[number];

export type DeviceLocaleFallbackRule =
	| { exclude: readonly string[] }
	| { include: readonly string[] };

export const DEVICE_LOCALE_FALLBACK_RULES: Partial<
	Record<Locale, DeviceLocaleFallbackRule>
> = {
	"en-GB": { exclude: ["en-US"] },
	"es-MX": { exclude: ["es-ES", "es"] },
	"fil-PH": { include: ["fil", "tl", "tl-PH"] },
	"fr-FR": { exclude: [] },
	"hi-IN": { exclude: [] },
	"id-ID": { exclude: [] },
	"ja-JP": { exclude: [] },
	"ko-KR": { exclude: [] },
	"ms-MY": { exclude: [] },
	"pa-IN": { exclude: ["pa-PK", "pa-Arab", "pa-Arab-PK"] },
	"th-TH": { exclude: [] },
	"tr-TR": { exclude: [] },
	"vi-VN": { exclude: [] },
	"zh-Hant-TW": { include: ["zh-TW", "zh-Hant"] },
};

export const i18nResources: Record<
	Locale,
	{ translation: Record<string, unknown> }
> = {
	"en-GB": { translation: translationEnGb },
	"en-US": { translation: translationEn },
	"es-MX": { translation: translationEs },
	"fil-PH": { translation: translationFil },
	"fr-FR": { translation: translationFr },
	"hi-IN": { translation: translationHi },
	"id-ID": { translation: translationId },
	"ja-JP": { translation: translationJa },
	"ko-KR": { translation: translationKo },
	"ms-MY": { translation: translationMs },
	"pa-IN": { translation: translationPa },
	"pt-BR": { translation: translationPt },
	"th-TH": { translation: translationTh },
	"tr-TR": { translation: translationTr },
	"vi-VN": { translation: translationVi },
	"zh-CN": { translation: translationZh },
	"zh-Hant-TW": { translation: translationZhHant },
} as const;

export const LANGUAGE_NAMES: Record<Locale, string> = {
	"en-GB": "English (UK)",
	"en-US": "English (US)",
	"es-MX": "Español",
	"fil-PH": "Filipino",
	"fr-FR": "Français",
	"hi-IN": "हिन्दी",
	"id-ID": "Bahasa Indonesia",
	"ja-JP": "日本語",
	"ko-KR": "한국어",
	"ms-MY": "Bahasa Melayu",
	"pa-IN": "ਪੰਜਾਬੀ",
	"pt-BR": "Português",
	"th-TH": "ไทย",
	"tr-TR": "Türkçe",
	"vi-VN": "Tiếng Việt",
	"zh-CN": "中文",
	"zh-Hant-TW": "繁體中文",
} as const;

export const LANGUAGES = LOCALES.map((locale) => ({
	code: locale,
	label: LANGUAGE_NAMES[locale],
}));

export type Language = (typeof LANGUAGES)[number];
